// Human-readable text for why a Plaid connection needs attention. Codes arrive
// either from Plaid item webhooks / API errors (stored on the enrollment's
// `disconnectReason`) or as a plain fallback string.
const REASON_TEXT = {
  ITEM_LOGIN_REQUIRED:     'your bank login details changed',
  PENDING_EXPIRATION:      'your bank requires you to re-authenticate soon',
  PENDING_DISCONNECT:      'your bank is ending this connection',
  ITEM_LOCKED:             'the bank has locked the account',
  USER_PERMISSION_REVOKED: 'access to this bank was revoked',
  USER_ACCOUNT_REVOKED:    'access to this account was revoked',
  INSTITUTION_DOWN:        'the bank is temporarily unavailable',
  INSTITUTION_NO_LONGER_SUPPORTED: 'this bank is no longer supported',
};

export function disconnectReasonText(code) {
  if (!code || typeof code !== 'string') return null;
  return REASON_TEXT[code] || null;
}
